module.exports = __webpack_public_path__ + "img/check.cec00a6c.svg";